import { ChangeEvent, DataSourceExecutionEvent } from "@mcleod/components";
import { AutogenLayoutSettlementMulticurrency } from "./autogen/AutogenLayoutSettlementMulticurrency";

export class SettlementMulticurrency extends AutogenLayoutSettlementMulticurrency {

    sourcePayrollControlMulticurrencyAfterExecution(event: DataSourceExecutionEvent) {
        this.updateClassDescriptionByFormat(this.activeRow.getString("dir_dep_format", ""));
    }

    private updateClassDescriptionByFormat(format: string): void {
        const isAchFormat = format === "A";

        this.horizontalspacer7.rowBreak = false;
        this.textboxDirDepClassDescCCD.visible = isAchFormat;
        this.textboxDirDepClassDescCCD.rowBreak = isAchFormat;
        this.textboxDirDepCompId.rowBreak = !isAchFormat;
        this.textboxDirDepClassDesc.caption = isAchFormat ? "Class Description - PPD" : "Class Description";
    }

    textboxDirDepFormatOnChange(event: ChangeEvent) {
        const selectedFormat = this.textboxDirDepFormat.selectedItem?.value ?? this.activeRow.getString("dir_dep_format", "");
        switch (selectedFormat) {
            case ("B"):
            case ("T"):
                this.textboxOriginatorId.enabled = true
                this.textboxOriginatorId.required = true
                this.textboxCpaCode.enabled = true
                this.textboxCpaCode.required = true
                break;
            case ("A"):
            case ("E"):
            default:
                this.textboxOriginatorId.enabled = false
                this.textboxOriginatorId.required = false
                this.textboxCpaCode.enabled = false
                this.textboxCpaCode.required = false
        }
        this.updateClassDescriptionByFormat(selectedFormat);
    }
}
